import { RequestMethod } from '../../enums/request-method';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a RestApiReceiver task — an HTTP trigger that exposes an endpoint
 * on the iHub microservice. Incoming requests to the endpoint start the flow.
 */
export class RestApiReceiverConfig extends DestinationTaskConfigBase {
	/**
	 * The HTTP method this endpoint accepts (GET, POST, PUT, DELETE, PATCH).
	 * HEAD requests are always accepted regardless of this setting and short-circuit the flow.
	 * @default RequestMethod.GET
	 */
	httpMethod = RequestMethod.GET;

	/**
	 * The URL path segment appended to the iHub base URL to form the full endpoint address.
	 * Use `'default'` for a single receiver per flow, or a custom slug when the flow
	 * has multiple receivers that must be distinguished by path.
	 * @default 'default'
	 */
	endpoint = 'default';

	/**
	 * The fully-qualified URL for this receiver endpoint.
	 * Computed and stored server-side after flow registration — do not set manually.
	 * @default ''
	 */
	url = '';

	/**
	 * When `true`, the endpoint holds the HTTP connection open until the flow completes
	 * and returns the flow result as the response body.
	 * When `false`, the endpoint returns `202 Accepted` immediately and the flow runs
	 * asynchronously.
	 * @default false
	 */
	isSync = false;

	constructor(init?: Partial<RestApiReceiverConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
